/**
 * Returns the no. of unique users in an array with `user` key
 *
 * @param {Array} userArr Array of user
 * @returns
 */
const uniqueLength = (userArr) => {
	return [...new Set(userArr.map(({user}) => user))].length
}

export {
    uniqueLength
}